import { render, staticRenderFns } from "./ThreadsWidget.vue?vue&type=template&id=1e0d0cc0&"
import script from "./ThreadsWidget.vue?vue&type=script&lang=js&"
export * from "./ThreadsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports